import React, { createRef } from 'react'
import styled from 'styled-components'
import IEventedComponent, {
  messageTypes
} from '../components/IEventedComponent'

const Container = styled.div`
  margin-bottom: 26px;
  width: 100%;
  text-align: left;
`

const Caption = styled.div`
  font-size: smaller;
  margin-top: 12px;
`

interface IProps {
  id: string
}

class YouTube extends IEventedComponent<IProps, {}> {
  componentDidMount() {
    this.subscribe(messageTypes.onSceneChanged, this.handleSceneChanged)
  }

  handleSceneChanged = () => {
    const msg = JSON.stringify({
      event: 'command',
      func: 'stopVideo',
      args: ''
    })
    this.iFrameRef.current?.contentWindow?.postMessage(msg, '*')
  }

  iFrameRef = createRef<HTMLIFrameElement>()

  render() {
    return (
      <Container>
        <iframe
          title="youtube video"
          ref={this.iFrameRef}
          width="416"
          height="234"
          src={`https://www.youtube.com/embed/${this.props.id}?enablejsapi=1&rel=0`}
          frameBorder={0}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ maxWidth: '100%' }}
        />
        <Caption>{this.props.children}</Caption>
      </Container>
    )
  }
}

export default YouTube
